import { useTranslation } from 'react-i18next';
import { Translate, KeyOfDictionary, Lang } from '@/types';
import { useHistory, useLocation } from 'react-router-dom';
import {
  generateQueryParamsFromObjectQuery,
  generateQueryParamsFromStringQuery,
} from '@/utils/helper';

const LangGenerator = ({ translation }: Translate) => {
  const { ...Dictionary } = translation;
  return {
    translation: {
      ...Dictionary,
    },
  };
};

const setLangStorage = (lang: Lang) => {
  localStorage.setItem('lang', lang);
};
const getLangStorage = () => localStorage.getItem('lang') as Lang;
const isAvailableLanguage = (lang: string): lang is Lang => {
  return ['id', 'en'].includes(lang as Lang);
};

const useTranslate = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const queryParamsObject = generateQueryParamsFromStringQuery(location.search);
  const translate = (keyWord?: KeyOfDictionary) => (keyWord ? t(keyWord) : '');
  const translateToId = (keyWord?: KeyOfDictionary) =>
    keyWord ? t(keyWord, { lng: 'id' }) : '';
  const changeLanguage = (key: Lang) => {
    i18n.changeLanguage(key);
    setLangStorage(key);
  };
  const setLNGQueryParams = (lng: Lang) => {
    const newQuery = generateQueryParamsFromObjectQuery({
      ...queryParamsObject,
      lng,
    });
    history.push({
      pathname: location.pathname,
      search: newQuery,
    });
  };
  const checkStorageWhenLngQueryIsNotExist = () => {
    if (!queryParamsObject.lng) {
      const lngStorage = getLangStorage();
      changeLanguage(lngStorage);
      setLNGQueryParams(lngStorage);
    }
  };
  const { language } = i18n;
  const currentLanguage = isAvailableLanguage(language) ? language : 'id';
  return {
    translate,
    changeLanguage,
    currentLanguage,
    checkStorageWhenLngQueryIsNotExist,
    setLNGQueryParams,
    translateToId,
  };
};

export { useTranslate, setLangStorage, getLangStorage };
export default LangGenerator;
